import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetOrderQuestionsPaymentPage } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutPaymentInformationCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const config = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  return (
    <Button<'a'>
      color="secondary"
      href={urlResolverGetOrderQuestionsPaymentPage({
        config,
        orderId: lastOrder.orderMasterData.orderNumber,
        params: {
          paymentType: subOrder.payment?.paymentKind,
        },
        subOrderId: subOrder.subOrderId,
      })}
      size="small"
    >
      <FormattedMessage id="account.orders.details.collapsible.label.paymentMethodTitle" />
    </Button>
  )
}
